import { render, staticRenderFns } from "./strategy-resume.component.vue?vue&type=template&id=87b33220"
import script from "./strategy-resume.component.vue?vue&type=script&lang=js"
export * from "./strategy-resume.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports